import { render, staticRenderFns } from "./MenuModuleFooter.vue?vue&type=template&id=4f770cdf&scoped=true"
import script from "./MenuModuleFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuModuleFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MenuModuleFooter.vue?vue&type=style&index=0&id=4f770cdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f770cdf",
  null
  
)

export default component.exports